


























































/* eslint-disable no-param-reassign */
import { FormBlock } from '@/app/components';
import { useAsset } from '@/modules/asset/composable/asset';
import { CollectionIcon, DatabaseIcon, UserIcon } from '@vue-hero-icons/solid';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'AssetDetails',
    components: {
        FormBlock,
        UserIcon,
        CollectionIcon,
        DatabaseIcon,
    },
    props: {
        contract: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const { assetTypeName } = useAsset();
        return { assetTypeName };
    },
});
